export default {
  FETCH_PROJECT_FINDERS_REQUEST: 'FETCH_PROJECT_FINDERS_REQUEST',
  FETCH_PROJECT_FINDERS_SUCCESS: 'FETCH_PROJECT_FINDERS_SUCCESS',
  FETCH_PROJECT_FINDERS_FAILURE: 'FETCH_PROJECT_FINDERS_FAILURE',
  UPDATE_PROJECT_FINDERS: 'UPDATE_PROJECT_FINDERS'
}
